import { CloseIcon } from "../../assets/icons/icons";
import "./category.css";

const extractTag = (text, tag) => {
    const regex = new RegExp(`<${tag}>(.*?)<\/${tag}>`, "s");
    const match = text?.match(regex);
    return match ? match[1].trim() : "";
};

const CategoryInfoModal = ({ isOpen, closeModal, data }) => {
    if (!isOpen) return null;

    // Extract header and paragraph from description string
    const title = extractTag(data, "header");
    const paragraph = extractTag(data, "paragraph");

    console.log("data", data);

    return (
        <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>{title}</h2>
                    <CloseIcon onClick={closeModal} className="cancel-icon" />
                </div>

                <div className="instructions-body">
                    <div className="tool-tip-container">
                        <p className="tool-tip-text">
                            {paragraph}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CategoryInfoModal;
